/* eslint-disable consistent-return */
import { Button, Grid, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import {
  getContractTypes,
  getJobs,
  getTeamById,
  inviteStudentSchool,
} from '@webapps/business';
import {
  FormikAutocomplete,
  FormikAutocomplete50,
  FormikAutocompletePx,
  TextField,
  useAuth,
  useLocalStorage,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const inviteStudentSchema = yup.object().shape({
  students: yup.array(),
  type: yup.string(),
  groupId: yup.string().required('Requis'),
  job: yup.object().shape({
    ogr: yup.string().required('Requis'),
  }),
  contractType: yup.object().shape({
    id: yup.string().required('Requis'),
  }),
});

const InviteStudent = ({ close }) => {
  const {
    css,
    theme: { spacing },
  } = useStyles();

  const { idUser } = useAuth();

  const { data: { content: teams = [] } = {}, isLoading: teamsLoading } =
    useQuery(getTeamById, {
      key: 'classroom',
      variables: { id: idUser },
    });

  const { data: contractTypes = [] } = useQuery(getContractTypes, {
    key: 'contractTypes',
  });

  const [keywordRequest, setKeywordRequest, removeKeywordRequest] =
    useLocalStorage('jobsKeyword');

  const { data: { content: jobs = [] } = {} } = useQuery(getJobs, {
    key: ['jobs', keywordRequest],
    variables: { keyword: keywordRequest || '' },
  });

  const {
    isLoading,
    isSuccess,
    mutate: mutateInviteStudent,
  } = useMutation(inviteStudentSchool);

  const { addToast } = useToast();

  const [errorEmail, setErrorEmail] = useState(false);
  const [errorEmailExist, setErrorEmailExist] = useState(false);
  const [email, setEmail] = useState('');
  const [listEmail, setListEmail] = useState([]);

  const handleChangeEmail = (labelEmail) => {
    const re = /\S+@\S+\.\S+/;
    setErrorEmail(false);
    setErrorEmailExist(false);
    if (re.test(labelEmail)) {
      setEmail(labelEmail);
      return true;
    }
    setErrorEmail(true);
    return false;
  };

  //   const addToListEmail = () => {
  //     if (email && handleChangeEmail(email)) {
  //       if (listEmail.includes(email)) {
  //         setErrorEmailExist(true);
  //       } else {
  //         setListEmail([...listEmail, email]);
  //         setEmail('');
  //       }
  //     }
  //   };

  const checkEmail = (val) => {
    if (val && handleChangeEmail(val)) {
      if (listEmail.includes(val)) {
        setErrorEmailExist(true);
      } else {
        // setListEmail([...listEmail, email]);
        setEmail(val);
      }
    }
  };

  const removeEmailToList = (labelToDelete) => {
    const newList = listEmail.filter((item) => item !== labelToDelete);
    setListEmail(newList);
  };

  useEffect(() => {
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Invitation(s) envoyé(s)',
      });
      close();
      removeKeywordRequest();
    }
  }, [isSuccess]);

  const formik = useFormik({
    initialValues: {
      students: listEmail,
      groupId: '',
      type: 'join_team',
      contractType: {
        id: '',
      },
      job: {
        ogr: '',
      },
    },
    validationSchema: inviteStudentSchema,
    onSubmit: async ({ contractType, groupId, job }) => {
      await mutateInviteStudent({
        data: {
          students: [...listEmail, email],
          groupId,
          type: 'join_team',
          contractType: contractType.id,
          job: job.ogr,
        },
      });
    },
  });

  return (
    <div>
      <Grid className={css({ marginTop: spacing(1) })} container spacing={2}>
        <Grid item xs={12}>
          <FormikAutocompletePx
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => value.id === option.id}
            label="Sélectionner une équipe existante"
            loading={teamsLoading}
            loadingText={
              <>
                <FormattedMessage id="loading" />
                ...
              </>
            }
            name="groupId"
            options={teams}
            pathValue="id"
            value={teams.find(({ id }) => id === formik.values.groupId) || null}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            className={css({ marginRight: spacing(1) })}
            fullWidth
            label="Adresse mail"
            onChange={(event) => {
              checkEmail(event.target.value);
            }}
            borderRadius={400}
            type="email"
          // value={email}
          />
        </Grid>
        <Grid item xs={12}>
          <FormikAutocompletePx
            defaultValue=""
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => value.id === option.id}
            label="Type de contrat"
            name="contractType.id"
            options={contractTypes}
            pathValue="id"
            value={
              contractTypes.find(
                ({ id }) => id === formik.values.contractType.id
              ) || null
            }
          />
        </Grid>
        <Grid item xs={12}>
          <FormikAutocompletePx
            defaultValue=""
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => value.ogr === option.ogr}
            label="Indiquer l'intitulé du poste"
            name="job.ogr"
            onInputChange={(event, value) => {
              setKeywordRequest(value);
            }}
            options={jobs}
            pathValue="ogr"
            value={
              jobs.find(({ ogr }) => ogr === formik.values.job.ogr) || null
            }
          />
        </Grid>
        {/* <Grid
          className={css({
            display: 'flex',
            alignItems: 'center',
            marginTop: spacing(0),
          })}
          item
          xs={12}
        >
          <EmailIcon color="primary" />
          <div className={css({ marginLeft: spacing(1), color: 'black' })}>
            Ajouter un mail
          </div>
        </Grid>
        <Grid
          className={css({
            marginTop: spacing(0),
            display: 'flex',
          })}
          item
          xs={12}
        >
          <TextField
            className={css({ marginRight: spacing(1) })}
            fullWidth
            label="Taper une adresse mail"
            onChange={(event) => {
              setEmail(event.target.value);
            }}
            type="email"
            value={email}
          />
          <Button
            className={css({ marginLeft: spacing(1) })}
            color="primary"
            onClick={addToListEmail}
            
            variant="outlined"
          >
            Ajouter
          </Button>
        </Grid> */}
        {errorEmail && (
          <Grid
            className={css({
              display: 'flex',
              marginTop: spacing(0),
              color: 'red',
            })}
            item
            xs={12}
          >
            <div>Veuillez saisir un e-mail valide svp!</div>
          </Grid>
        )}
        {errorEmailExist && (
          <Grid
            className={css({
              display: 'flex',
              marginTop: spacing(0),
              color: 'red',
            })}
            item
            xs={12}
          >
            <div>E-mail déja renseigné!</div>
          </Grid>
        )}
        {/* {listEmail.length <= 0 && (
          <Grid
            className={css({ display: 'flex', marginTop: spacing(0) })}
            item
            xs={12}
          >
            <div>Aucun email saisi</div>
          </Grid>
        )} */}

        {listEmail.length > 0 && (
          <Grid
            className={css({
              marginTop: spacing(0),
              maxHeight: 250,
              overflow: 'auto',
            })}
            item
            xs={12}
          >
            {listEmail.map((item, index) => (
              <div
                key={index}
                className={css({
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                })}
              >
                <div>{item}</div>
                <div>
                  <IconButton
                    color="secondary"
                    onClick={() => removeEmailToList(item)}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              </div>
            ))}
          </Grid>
        )}
      </Grid>
      <Grid container spacing={2}>
        <Grid className={css({ textAlign: 'center', marginTop: spacing(4) })} item xs>
          <Button
            className={css({ borderRadius: '400px' })}
            color="primary"
            disabled={isLoading}
            onClick={formik.handleSubmit}
            variant="contained"
          >
            Envoyer l'invitation
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

InviteStudent.propTypes = {
  close: PropTypes.func,
};

export default InviteStudent;
